module.exports = __webpack_public_path__ + "25162bf857a8eb83ea932a58436e1049.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/misc/ui/images/ui-icons_2e83ff_256x240.png
// module id = 250
// module chunks = 0